import type { FunctionComponent } from "react";
import Carousel from "react-multi-carousel";
import type { ResponsiveType } from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { AuthenticatedImage } from "./chat-message-authenticated-image";
import { removeParagraphImageWrapper } from "~/utils/html.utils";
import { rehypeTableCaption } from "~/utils/rehype-table-caption";
import { ChatMessageAnchor } from "./chat-message-anchor";

const CAROUSEL_RESPONSIVE: ResponsiveType = {
  desktopXL: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

interface ChatMessageCarouselProps {
  slides: string[];
}

export const ChatMessageCarousel: FunctionComponent<ChatMessageCarouselProps> = ({ slides }) => (
  <div className="chat-carousel">
    <Carousel
      responsive={CAROUSEL_RESPONSIVE}
      showDots
      infinite={false}
      arrows
      keyBoardControl
      containerClass="chat-carousel-container"
      itemClass="chat-carousel-item"
    >
      {slides.map((slide, index) => (
        <div key={index} className="chat-carousel-slide">
          <Markdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw, rehypeTableCaption]}
            components={{
              img: ({ src, alt }) => <AuthenticatedImage url={src ?? ""} alt={alt ?? ""} />,
              p: removeParagraphImageWrapper,
              a: ({ href, children }) => <ChatMessageAnchor href={href}>{children}</ChatMessageAnchor>,
            }}
          >
            {slide}
          </Markdown>
        </div>
      ))}
    </Carousel>
  </div>
);
